// src/utils/trackEvent.js
import { getSessionId } from './sessionId';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const normalizeHotelId = (hotelId) => {
  if (hotelId === undefined || hotelId === null || hotelId === '') return null;
  return hotelId;
};

const getStoredHotelId = () => {
  try {
    const lastJourneyHotelId = normalizeHotelId(sessionStorage.getItem('journey_hotel_id'));
    if (lastJourneyHotelId) return lastJourneyHotelId;

    const bookingSession = sessionStorage.getItem('bookingSession');
    if (bookingSession) {
      const parsed = JSON.parse(bookingSession);
      const hotelId = normalizeHotelId(parsed?.searchState?.hotelId);
      if (hotelId) return hotelId;
    }

    const bookingInfo = sessionStorage.getItem('bookingInfo');
    if (bookingInfo) {
      const parsed = JSON.parse(bookingInfo);
      const hotelId = normalizeHotelId(parsed?.hotelId);
      if (hotelId) return hotelId;
    }
  } catch (e) {
    console.warn('Unable to read stored hotel id for tracking', e);
  }

  return normalizeHotelId(new URLSearchParams(window.location.search).get('hotel_id'));
};

export async function trackEvent(eventType, payload = {}) {
  try {
    const hotelId = normalizeHotelId(payload.hotel_id) || getStoredHotelId();
    if (hotelId) {
      sessionStorage.setItem('journey_hotel_id', hotelId);
    }

    await fetch(`${API_BASE_URL}/fe/journeyEvent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json',},
      body: JSON.stringify({
        session_id: getSessionId(),
        event_type: eventType,
        ...payload,
        hotel_id: hotelId,
      }),
      keepalive: true, // lets the request finish even if the page navigates away
    });
  } catch (e) {
    console.warn('trackEvent failed', eventType, e);
  }
}
